import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'refresh-token',
  templateUrl: './refresh-token.component.html'
})
export class RefreshTokenComponent implements OnInit {
  constructor(private authService: AuthService) {
  }
  ngOnInit() {
    console.log('RefreshTokenComponent');
    this.authService.processCallbackRefresh();
  }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/auth/refresh-token/refresh-token.component.ts